export function jsonToQueryString(json) {
  return Object.keys(json)
    .filter((key) => json[key] !== null && json[key] !== undefined)
    .map((key) => {
      if (Array.isArray(json[key])) {
        // If the value is an array, create multiple key-value pairs
        return json[key]
          .map(
            (value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&');
      } else {
        // If the value is not an array, create a single key-value pair
        return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
      }
    })
    .filter(Boolean)
    .join('&');
}

export function parseNumericStrings(json) {
  const result = {};
  for (const key in json) {
    if (Object.prototype.hasOwnProperty.call(json, key)) {
      const value = json[key];
      // Check if the value is a numeric string and parse it to a number
      result[key] = /^\d+(\.\d+)?$/.test(value) ? parseFloat(value) : value;
    }
  }
  return result;
}
